// equipment-tree-state.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EquipmentTreeStateService {
  private readonly expandedNodes = new Map<string, Set<string>>();

  saveExpandedNodes(equipmentId: string, nodeIds: string[]) {
    this.expandedNodes.set(equipmentId, new Set(nodeIds));
  }

  getExpandedNodes(equipmentId: string): Set<string> {
    return this.expandedNodes.get(equipmentId) || new Set();
  }

  clearState(equipmentId: string) {
    this.expandedNodes.delete(equipmentId);
  }
}
